<ion-content #listContainer [scrollY]="false">
    <ng-container *ngIf="_displayedJobList.length == 0; else listContent">
        <div class="dp-center-notice">{{ 'projects.plans.job-list.no-jobs-info' | translate }}</div>
    </ng-container>

    <ng-template #listContent>
        <cdk-virtual-scroll-viewport itemSize="72" #itemList class="ion-content-scroll-host" [class.list-margin-bottom]="utils.isPhone">
            <ion-list>
                <!-- <ion-item-divider color="none" mode="md">
                    <ion-label>headername</ion-label>
                    <ion-badge slot="end" class="ion-margin-end" color="warning" *ngIf="!false">Unveränderbar</ion-badge>
                </ion-item-divider> -->
                <ion-item
                    button
                    class="job-list-item"
                    *cdkVirtualFor="let j of _displayedJobList; trackBy: jobListTrackBy"
                    detail="false"
                    lines="full"
                    (click)="onJobListItemSelect(j)"
                    [class.ion-item-active]="_activeId === j.marker._id"
                >
                    <div class="job-number" slot="start">
                        <ion-label>{{ j.jobNumber }}</ion-label>
                    </div>

                    <div class="job-details" tabindex="0">
                        <div class="job-name">
                            <ion-label>{{ j.name }}</ion-label>
                            <span
                                class="marker-name"
                                *ngIf="
                                    j.marker.markerName != null &&
                                    j.marker.markerName.trim() !== '' &&
                                    j.jobNumber.trim() !== j.marker.markerName.trim()
                                "
                                >{{ j.marker.markerName }}</span
                            >
                        </div>
                        <div class="job-meta">
                            <span class="job-code" *ngIf="j.code">
                                <ion-chip color="primary" outline="true">
                                    <fa-icon [icon]="['fal', 'qrcode']"></fa-icon>
                                    <ion-label>{{ j.code }}</ion-label>
                                </ion-chip>
                            </span>
                        </div>
                    </div>

                    <span class="dp-marker" *ngIf="j.marker" slot="end">
                        <i class="fad fa-map-pin fa-lg"></i>
                    </span>
                </ion-item>
            </ion-list>
        </cdk-virtual-scroll-viewport>
        <!--	<ion-virtual-scroll
			[items]="_displayedJobList"
			[trackBy]="jobListTrackBy"
			#itemList
			[approxItemHeight]="72"
			[approxHeaderHeight]="44"
			[itemHeight]="jobItemHeightFn"
			[headerFn]="jobItemHeaderFn"
			[headerHeight]="jobHeaderHeightFn"
			[class.list-margin-bottom]="utils.isPhone"
		>
			<ion-item-divider *virtualHeader="let header" color="none" mode="md">
				<ion-label>{{ header.name }}</ion-label>
				<ion-badge slot="end" class="ion-margin-end" color="warning" *ngIf="!header.editable"
					>Unveränderbar</ion-badge
				>
			</ion-item-divider>
			<ion-item
				button
				class="job-list-item"
				*virtualItem="let j"
				detail="false"
				lines="full"
				(click)="onJobListItemSelect(j)"
				[class.ion-item-active]="_activeId === j.marker._id"
			>
				<div class="job-number" slot="start">
					<ion-label>{{ j.jobNumber }}</ion-label>
				</div>

				<div class="job-details" tabindex="0">
					<div class="job-name">
						<ion-label>{{ j.name }}</ion-label>
                        <span class="marker-name" *ngIf="j.marker.markerName != null && j.marker.markerName.trim() !== '' && j.jobNumber.trim() !== j.marker.markerName.trim()">{{ j.marker.markerName }}</span>
					</div>
					<div class="job-meta">
						<span class="job-code" *ngIf="j.code">
							<ion-chip color="primary" outline="true">
								<fa-icon [icon]="['fal', 'qrcode']"></fa-icon>
								<ion-label>{{ j.code }}</ion-label>
							</ion-chip>
						</span>
					</div>
				</div>

				<span class="dp-marker" *ngIf="j.marker" slot="end">
					<i class="fad fa-map-pin fa-lg"></i>
				</span>
			</ion-item>
		</ion-virtual-scroll>-->
    </ng-template>
</ion-content>
